import React from 'react';

const Content = ({children}) =>{
   return (
    <div id='content'>
    {children}
     </div>
   );
}

export default Content;

